export const Environment = {
  local: {
    MICROSOFT_APP_ID: "af14ac7f-7a33-4d98-9c90-1e31285a5aa9",
    MICROSOFT_APP_PASSWORD: "c6G8Q~tu_rEXbOdGECIQ74H3qJTGTuE2oqD7.baX",
    CONNECTION_NAME: "RecTeamBotSetting",
    DOMAIN: "teams.recognitionnow.com",
    AUTH_SERVICE_URL: "https://beacon.biworldwide.com/recognitionApp_redirect/something.do",
    REDIS_URL:"http://gts-addins-cache-cluster-prod-931460942.ap-south-1.elb.amazonaws.com/redis",
    EMAIL_FETCH_URL:
      "https://beacon.biworldwide.com/recognitionApp_redirect/getContactUsEmail.action",
    SUCCESS_IMAGE:
      "https://teams.recognitionnow.com/assets/images/pointsSuccess.png",
    WELCOME_IMAGE:
      "https://teams.recognitionnow.com/assets/images/welcomecard.png",
  },
  test: {
    MICROSOFT_APP_ID: "12dbc153-76ac-4ba3-a785-8242ebe01d46",
    MICROSOFT_APP_PASSWORD: "yoS7Q~L.iRHy.ILejitPnwclsZL5rOXlSWKWC",
    CONNECTION_NAME: "RecTeamBotSetting",
    DOMAIN: "https://qa.recognition-webview.biw.cloud",
    AUTH_SERVICE_URL:
      "https://beaconpprd.biworldwide.com/recognitionApp_redirect/something.do",
    REDIS_URL:"http://gts-addins-cache-cluster-qa-1310809054.ap-south-1.elb.amazonaws.com/redis",
    EMAIL_FETCH_URL:
      "https://beaconpprd.biworldwide.com/recognitionApp_redirect/getContactUsEmail.action",
    SUCCESS_IMAGE:
      "https://qa.teams.recognitionnow.com/assets/images/pointsSuccess.png",
    WELCOME_IMAGE:
    "https://qa.teams.recognitionnow.com/assets/images/welcomecard.png",
  },
  qa: {
    MICROSOFT_APP_ID: "86f8ccff-0546-47e4-9195-aac03df4d52d",
    MICROSOFT_APP_PASSWORD: "qdkV7Q.8_a4D_3HgV~w22.O.58K3Ik5-ZU",
    CONNECTION_NAME: "RecTeamBotSetting",
    DOMAIN: "qa.teams.recognitionnow.com",
    AUTH_SERVICE_URL:
      "https://beaconpprd.biworldwide.com/recognitionApp_redirect/something.do",
    REDIS_URL:"http://gts-addins-cache-cluster-qa-1310809054.ap-south-1.elb.amazonaws.com/redis",
    EMAIL_FETCH_URL:
      "https://beaconqa.biworldwide.com/recognitionApp_redirect/getContactUsEmail.action",  
    SUCCESS_IMAGE:
      "https://qa.teams.recognitionnow.com/assets/images/pointsSuccess.png",
    WELCOME_IMAGE:
      "https://qa.teams.recognitionnow.com/assets/images/welcomecard.png",
  },
  pprd: {
    MICROSOFT_APP_ID: "86f8ccff-0546-47e4-9195-aac03df4d52d",
    MICROSOFT_APP_PASSWORD: "qdkV7Q.8_a4D_3HgV~w22.O.58K3Ik5-ZU",
    CONNECTION_NAME: "RecTeamBotSetting",
    DOMAIN: "pprd.teams.recognitionnow.com",
    AUTH_SERVICE_URL:
      "https://beaconpprd.biworldwide.com/recognitionApp_redirect/something.do",
    REDIS_URL:"http://gts-addins-cache-cluster-qa-1310809054.ap-south-1.elb.amazonaws.com/redis", 
         
    EMAIL_FETCH_URL:
      "https://beaconpprd.biworldwide.com/recognitionApp_redirect/getContactUsEmail.action",  
    SUCCESS_IMAGE:
      "https://pprd.teams.recognitionnow.com/assets/images/pointsSuccess.png",
    WELCOME_IMAGE:
      "https://pprd.teams.recognitionnow.com/assets/images/welcomecard.png",
  },
  prod: {
    MICROSOFT_APP_ID: "af14ac7f-7a33-4d98-9c90-1e31285a5aa9",
    MICROSOFT_APP_PASSWORD: "c6G8Q~tu_rEXbOdGECIQ74H3qJTGTuE2oqD7.baX",
    CONNECTION_NAME: "RecTeamBotSetting",
    DOMAIN: "teams.recognitionnow.com",
    AUTH_SERVICE_URL:
      "https://beacon.biworldwide.com/recognitionApp_redirect/something.do",
    REDIS_URL:"http://gts-addins-cache-cluster-prod-931460942.ap-south-1.elb.amazonaws.com/redis",      
    EMAIL_FETCH_URL:
      "https://beacon.biworldwide.com/recognitionApp_redirect/getContactUsEmail.action",  
    SUCCESS_IMAGE:
      "https://teams.recognitionnow.com/assets/images/pointsSuccess.png",
    WELCOME_IMAGE:
      "https://teams.recognitionnow.com/assets/images/welcomecard.png",
  },
};
